<div *ngIf="czyZaladowanoDane">
  <div class="container--main d-none d-md-block">
    <div class="ft__sort text-center pt-4">
      Generowanie raportu {{ pobierzNazweRaportu() }} - {{ adresLokalizacji }}
    </div>
  </div>
  <div class="container pt-4">
    <div class="f-input mb-1">
      <label for="" class="ft__label mb-1 text-left w-100">Lokalizacja:</label>
    </div>
    <div
      class="f-input mb-3 d-flex"
      [ngClass]="czyBladWalidacyjny('lokalizacja') ? 'error' : ''"
    >
      <input type="text" [(ngModel)]="model.lokalizacja" />
      <div
        class="btn__delete"
        style="visibility: hidden; align-self: center; margin-left: 10px"
      ></div>
    </div>
    <div
      class="error-info fs__error pt-2"
      *ngIf="czyBladWalidacyjny('lokalizacja')"
    >
      {{ pobierzBladWalidacyjny("lokalizacja") }}
    </div>
    <div class="f-input mb-1">
      <label
        for=""
        class="ft__label mb-1 text-left w-100"
        *ngIf="!czySpisSamodzielnyKlienta"
        >Przewodniczący zespołu IPRO:</label
      >
      <label
        for=""
        class="ft__label mb-1 text-left w-100"
        *ngIf="czySpisSamodzielnyKlienta"
        >Przewodniczący zespołu Spisowego:</label
      >
    </div>
    <div
      class="f-input mb-3 d-flex"
      [ngClass]="czyBladWalidacyjny('przewodniczacyZespolu') ? 'error' : ''"
    >
      <input type="text" [(ngModel)]="model.przewodniczacyZespolu" />
      <div
        class="btn__delete"
        style="visibility: hidden; align-self: center; margin-left: 10px"
      ></div>
    </div>
    <div
      class="error-info fs__error pt-2"
      *ngIf="czyBladWalidacyjny('przewodniczacyZespolu')"
    >
      {{ pobierzBladWalidacyjny("przewodniczacyZespolu") }}
    </div>
    <div *ngIf="!czySpisSamodzielnyKlienta">
      <div class="f-input mb-1">
        <label for="" class="ft__label mb-1 text-left w-100"
          >Członek zespołu:</label
        >
      </div>
      <div
        class="f-input mb-3 d-flex"
        [ngClass]="czyBladWalidacyjny('czlonekZespolu') ? 'error' : ''"
      >
        <input type="text" [(ngModel)]="model.czlonekZespolu" />
        <div
          class="btn__delete"
          style="visibility: hidden; align-self: center; margin-left: 10px"
        ></div>
      </div>
      <div
        class="error-info fs__error pt-2"
        *ngIf="czyBladWalidacyjny('czlonekZespolu')"
      >
        {{ pobierzBladWalidacyjny("czlonekZespolu") }}
      </div>
    </div>
    <div *ngIf="czySpisSamodzielnyKlienta">
      <div *ngFor="let wykonawca of model.wykonawcySpisu; let i = index; trackBy: trackByIndex">
        <div class="f-input mb-1">
          <label class="ft__label mb-1 text-left w-100">Wykonawca spisu:</label>
        </div>
        <div
          class="f-input mb-3 d-flex"
          [ngClass]="
            i === 0 && czyBladWalidacyjny('wykonawcySpisu') ? 'error' : ''
          "
        >
          <input
            type="text"
            [(ngModel)]="model.wykonawcySpisu[i]"
            placeholder="Imię i nazwisko wykonawcy"
          />
          <button
            *ngIf="i > 0"
            type="button"
            class="btn__delete"
            (click)="usunWykonawce(i)"
            title="Usuń wykonawcę"
            style="align-self: center; margin-left: 10px"
          ></button>
          <div
            *ngIf="i === 0"
            class="btn__delete"
            style="visibility: hidden; align-self: center; margin-left: 10px"
          ></div>
        </div>
        <div
          class="error-info fs__error pt-2"
          *ngIf="i === 0 && czyBladWalidacyjny('wykonawcySpisu')"
        >
          {{ pobierzBladWalidacyjny("wykonawcySpisu") }}
        </div>
      </div>
      <div class="f-input mb-5 d-flex">
        <button type="button" class="btn__border" (click)="dodajWykonawce()">
          Dodaj wykonawcę
        </button>
        <div
          class="btn__delete"
          style="visibility: hidden; align-self: center; margin-left: 10px"
        ></div>
      </div>
    </div>
    <div class="f-input mb-1">
      <label for="" class="ft__label mb-1 text-left w-100">Klient:</label>
    </div>
    <div
      class="f-input mb-3 d-flex"
      [ngClass]="czyBladWalidacyjny('klient') ? 'error' : ''"
    >
      <input type="text" [(ngModel)]="model.klient" />
      <div
        class="btn__delete"
        style="visibility: hidden; align-self: center; margin-left: 10px"
      ></div>
    </div>
    <div class="error-info fs__error pt-2" *ngIf="czyBladWalidacyjny('klient')">
      {{ pobierzBladWalidacyjny("klient") }}
    </div>

    <div *ngIf="!czySpisSamodzielnyKlienta">
      <div class="f-input mb-1">
        <label for="" class="ft__label mb-1 text-left w-100"
          >Przedstawiciel Klienta:</label
        >
      </div>
      <div
        class="f-input mb-3 d-flex"
        [ngClass]="czyBladWalidacyjny('przedstawicielKlienta') ? 'error' : ''"
      >
        <input type="text" [(ngModel)]="model.przedstawicielKlienta" />
        <div
          class="btn__delete"
          style="visibility: hidden; align-self: center; margin-left: 10px"
        ></div>
      </div>
      <div
        class="error-info fs__error pt-2"
        *ngIf="czyBladWalidacyjny('przedstawicielKlienta')"
      >
        {{ pobierzBladWalidacyjny("przedstawicielKlienta") }}
      </div>
    </div>

    <label class="ft__07 por" for="">Spis rozpoczęto:</label>
    <div class="d-flex">
      <div style="flex: 1; padding-right: 8px">
        <div
          class="f-input mb-3 d-flex"
          [ngClass]="czyBladWalidacyjny('spisRozpoczetoData') ? 'error' : ''"
        >
          <input
            mask="00-00-0000"
            [specialCharacters]="['-']"
            [dropSpecialCharacters]="false"
            type="text"
            [(ngModel)]="model.spisRozpoczetoData"
          />
          <div
            class="btn__delete"
            style="visibility: hidden; align-self: center; margin-left: 10px"
          ></div>
        </div>
        <div
          class="error-info fs__error pt-2"
          *ngIf="czyBladWalidacyjny('spisRozpoczetoData')"
        >
          {{ pobierzBladWalidacyjny("spisRozpoczetoData") }}
        </div>
      </div>
      <div
        style="flex: 1; padding-left: 8px"
        *ngIf="!czySpisSamodzielnyKlienta"
      >
        <div
          class="f-input mb-3 d-flex"
          [ngClass]="czyBladWalidacyjny('spisRozpoczetoGodzina') ? 'error' : ''"
        >
          <input
            type="text"
            mask="Hh:m0"
            [specialCharacters]="[':']"
            [dropSpecialCharacters]="false"
            [(ngModel)]="model.spisRozpoczetoGodzina"
          />
          <div
            class="btn__delete"
            style="visibility: hidden; align-self: center; margin-left: 10px"
          ></div>
        </div>
        <div
          class="error-info fs__error pt-2"
          *ngIf="czyBladWalidacyjny('spisRozpoczetoGodzina')"
        >
          {{ pobierzBladWalidacyjny("spisRozpoczetoGodzina") }}
        </div>
      </div>
    </div>

    <label class="ft__07 por" for="">Spis zakończono:</label>
    <div class="d-flex">
      <div style="flex: 1; padding-right: 8px">
        <div
          class="f-input mb-3 d-flex"
          [ngClass]="czyBladWalidacyjny('spisZakonczonoData') ? 'error' : ''"
        >
          <input
            mask="00-00-0000"
            [specialCharacters]="['-']"
            [dropSpecialCharacters]="false"
            type="text"
            [(ngModel)]="model.spisZakonczonoData"
          />
          <div
            class="btn__delete"
            style="visibility: hidden; align-self: center; margin-left: 10px"
          ></div>
        </div>
        <div
          class="error-info fs__error pt-2"
          *ngIf="czyBladWalidacyjny('spisZakonczonoData')"
        >
          {{ pobierzBladWalidacyjny("spisZakonczonoData") }}
        </div>
      </div>
      <div
        style="flex: 1; padding-left: 8px"
        *ngIf="!czySpisSamodzielnyKlienta"
      >
        <div
          class="f-input mb-3 d-flex"
          [ngClass]="czyBladWalidacyjny('spisZakonczonoGodzina') ? 'error' : ''"
        >
          <input
            mask="Hh:m0"
            type="text"
            [specialCharacters]="[':']"
            [dropSpecialCharacters]="false"
            [(ngModel)]="model.spisZakonczonoGodzina"
          />
          <div
            class="btn__delete"
            style="visibility: hidden; align-self: center; margin-left: 10px"
          ></div>
        </div>
        <div
          class="error-info fs__error pt-2"
          *ngIf="czyBladWalidacyjny('spisZakonczonoGodzina')"
        >
          {{ pobierzBladWalidacyjny("spisZakonczonoGodzina") }}
        </div>
      </div>
    </div>

    <div class="f-input mb-1">
      <label for="" class="ft__label mb-1 text-left w-100"
        >Treść Uwagi i Zastrzeżenia :</label
      >
    </div>
    <div
      class="f-input mb-3 pb-1 d-flex"
      [ngClass]="czyBladWalidacyjny('uwagi') ? 'error' : ''"
    >
      <textarea class="big__textarea" [(ngModel)]="model.uwagi"></textarea>
      <div
        class="btn__delete"
        style="visibility: hidden; align-self: center; margin-left: 10px"
      ></div>
    </div>
    <div class="error-info fs__error pt-2" *ngIf="czyBladWalidacyjny('uwagi')">
      {{ pobierzBladWalidacyjny("uwagi") }}
    </div>

    <div
      class="chb por mb-3"
      *ngIf="this.idPomieszczenia || model.idPomieszczen.length == 1"
    >
      <input
        id="cb_nazwa_pomieszczenia"
        type="checkbox"
        name="czyDrukowacNazwePomieszczenia"
        [(ngModel)]="model.czyDrukowacNazwePomieszczenia"
      />
      <label class="fs__chb" for="cb_nazwa_pomieszczenia"
        >Widoczna nazwa pomieszczenia na arkuszu</label
      >
    </div>

    <div class="chb por mb-3">
      <input
        id="cb_czyDrukowacMpkLokalizacji"
        type="checkbox"
        name="czyDrukowacMpkLokalizacji"
        [(ngModel)]="model.czyDrukowacMpkLokalizacji"
      />
      <label class="fs__chb" for="cb_czyDrukowacMpkLokalizacji"
        >Widoczne MPK lokalizacji na arkuszu</label
      >
    </div>
  </div>
  <div class="container--main d-none d-md-block">
    <div class="ft__sort text-center pt-4">Kolumny raportu</div>
  </div>

  <div class="container pt-4 pb-md-5 mb-3">
    <div
      class="chb por mb-3 d-flex align-items-center"
      *ngFor="let kolumna of model.kolumny"
    >
      <input
        id="cb_{{ kolumna.kolumna }}"
        type="checkbox"
        name="{{ kolumna.kolumna }}"
        [(ngModel)]="kolumna.czyWybrano"
        (ngModelChange)="zmienionoZaznaczenie(kolumna)"
      />
      <label class="fs__chb flex-grow-1" for="cb_{{ kolumna.kolumna }}">{{
        kolumna.kolumna
      }}</label>
      <div class="szerokosc-kolumny" *ngIf="kolumna.czyWybrano">
        <input
          type="number"
          min="1"
          max="100"
          step="1"
          name="szerokosc_{{ kolumna.kolumna }}"
          title="Szerokość kolumny na wydruku"
          [class.szerokosc-kolumny--recznie]="czyKolumnaRecznie(kolumna)"
          [disabled]="pobierzAktywneKolumny().length <= 1"
          [(ngModel)]="kolumna.szerokosc"
          (change)="zmienionoSzerokosc(kolumna)"
        />
        <span class="fs__chb">%</span>
      </div>
    </div>
    <div
      class="d-flex justify-content-between align-items-center mb-2"
      *ngIf="pobierzAktywneKolumny().length > 0"
    >
      <span class="fs__chb">Suma: {{ sumaSzerokosci() }}%</span>
      <div class="d-flex align-items-center">
        <button type="button" class="btn__link" (click)="rozlozRowno()">
          Rozłóż równo
        </button>
        <button
          type="button"
          class="btn__border ml-3"
          *ngIf="czyAdmin()"
          (click)="zapiszSzerokosci()"
        >
          Zapisz szerokości
        </button>
      </div>
    </div>
    <div class="fs__login--info">
      Kolumna lp.{{
        model.rodzajRaportu == rodzajRaportu.niedobory ? " i Komentarz" : ""
      }}
      ma stałą szerokość - procenty dotyczą pozostałej szerokości strony.
      <span *ngIf="czyAdmin()">
        Zapisywane są tylko szerokości ustawione ręcznie (wyróżnione) - osobno
        dla raportu {{ pobierzNazweRaportu() }}; pozostałe kolumny dzielą
        resztę po równo.
      </span>
    </div>
    <div
      class="error-info fs__error pt-2"
      *ngIf="czyBladWalidacyjny('kolumny')"
    >
      {{ pobierzBladWalidacyjny("kolumny") }}
    </div>
  </div>

  <div class="bootom__buttons px-4 d-block">
    <div
      class="container--mw600 flex-column flex-md-row d-flex justify-content-between align-items-center"
    >
      <button class="btn__link order-1 order-md-0" (click)="anuluj()">
        Anuluj
      </button>
      <button
        class="btn__blue order-0 order-md-1 px-5 mb-md-0"
        (click)="generuj()"
      >
        Generuj
      </button>
    </div>
  </div>
</div>
